// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 动态拖拽菜单栏宽度 */\n:root {\n  --sideBarWidth: 200px;\n  /* 默认值，与 JS 中的初始值一致 */ }\n", ""]);
// Exports
exports.locals = {
	"menuText": "rgba(0, 0, 0, 0.65)",
	"menuActiveText": "#1890ff",
	"subMenuActiveText": "#1890ff",
	"menuBg": "white",
	"menuHover": "white",
	"subMenuBg": "white",
	"subMenuHover": "white",
	"sideBarWidth": "200px",
	"subMenuHoverTxt": "#1890ff",
	"menuHoverTxt": "#1890ff"
};
module.exports = exports;
